export const enableShadowDom = () => true;
export const unsafeDisableShadowDom = () => false;
